// extracted by mini-css-extract-plugin
module.exports = {"lock":"modal_lock__lf5GP","wrapper":"modal_wrapper__1Mmns","header":"modal_header__1RhY0","content":"modal_content__72sVd"};